:host {
    --cms-accordion-label-color: var(--cms-theme-text-color);
    --cms-accordion-background-color: var(--cms-semanticColors-transparency-strong-background);
    --cms-accordion-border: var(--cms-border-size-sm) solid var(--cms-theme-border-color);
    display: block;
}

.accordion-item {
    overflow: hidden;
    border: var(--cms-accordion-border);
    border-radius: var(--cms-border-radius-xs);
}

:host(:not(:last-child)) .accordion-item {
    margin-bottom: var(--cms-spacing-075);
}

.accordion-trigger {
    width: 100%;
    align-items: center;
    cursor: pointer;
    outline: 0;
    position: relative;
    padding: var(--cms-spacing-075) var(--cms-spacing-100);
    display: flex;
    flex-direction: row;
    align-content: center;
    justify-content: space-between;
    background: var(--cms-accordion-background-color);
    font-family: var(--cms-brandfont2), serif;
    font-size: var(--cms-font-size-112);
    line-height: var(--cms-line-height-120);
    font-weight: var(--cms-heading-base-font-weight);
    height: auto;
    border: none;
    overflow: hidden;
}

.accordion-trigger[aria-expanded='true'] {
    background: var(--cms-theme-strong-active-background);
}

.accordion-trigger:hover {
    background: var(--cms-theme-strong-hover);
}

.accordion-trigger:active {
    background: var(--cms-theme-strong-active-background);
}

.accordion-item:has(.accordion-trigger:focus-visible) {
    box-shadow: 0 0 0 var(--cms-spacing-012) var(--cms-semanticColors-container-focus-outlineInner),
        0 0 0 var(--cms-spacing-025) var(--cms-semanticColors-container-focus-outlineOuter)
}

.accordion-title {
    text-align: left;
    padding-right: var(--cms-spacing-025);
    color: var(--cms-accordion-label-color);
}

.accordion-panel {
    padding-top: var(--cms-spacing-100);
}

.accordion-panel[aria-hidden] {
    visibility: hidden;
}

@media (prefers-reduced-motion: reduce) {
    .accordion-item {
        transition: none !important;
    }
}